// extracted by mini-css-extract-plugin
module.exports =  {"tooltip-item":"tooltip-item-gfYXu"};